// extracted by mini-css-extract-plugin
export var brand = "_9x-9";
export var compact = "_9x-6";
export var extraSmall = "_9x-7";
export var icon = "_9x-0";
export var large = "_9x-4";
export var light = "_9x-1";
export var medium = "_9x-5";
export var outline = "_9x-b";
export var primaryDark = "_9x-a";
export var primaryLight = "_9x-8";
export var primaryModern = "_9x-c";
export var success = "_9x-2";
export var successSolid = "_9x-3";